import {useEffect, useState} from "react";
import useWindowDimensions from "./useWindowDimensions";

export const useCardDistributor = (parentContainerRef, parentPadding=0, cardWidth=200, maxCards=6, gap=10, poleFlag={}) => {
    let {width: windowWidth} = useWindowDimensions();
    const [maxCardsPerRow, setMaxCardsPerRow] = useState(maxCards);

    useEffect(() => {
        calculate();

        // setTimeout(() => {
        //     calculate();
        // }, 1000);

    }, [windowWidth, poleFlag]);

    const getDivisors = (n) => {
        let divisors = [];

        for (let i = 1; i <= n; i++) {
            if (n % i === 0) {
                divisors.push(i);
            }
        }

        return divisors;
    }

    const calculate = () => {
        if (!parentContainerRef.current) {
            return;
        }
        let {width} = parentContainerRef.current.getBoundingClientRect();

        let divisors = getDivisors(maxCards);
        for (let divisor of divisors) {
            let cardsPerRow = maxCards / divisor;
            let idealLength = cardWidth * cardsPerRow + gap * (cardsPerRow - 1);
            if ((width - parentPadding * 2) >= idealLength) {
                setMaxCardsPerRow(cardsPerRow);
                break;
            }
        }
    }

    return {maxCardsPerRow};
}